export interface IAppConfig {
  apiUrl: string;
  authKey: string;
}

export const AppConfig = Object.freeze(getConfig(process.env));

function getConfig(env: any): IAppConfig {

  const config: IAppConfig = {
    apiUrl: env.VUE_APP_API,
    authKey: env.VUE_APP_AUTH
  };

  return config;
}
